// extracted by mini-css-extract-plugin
export default {"wrapper":"header-logo-module--wrapper--28edf","logo":"header-logo-module--logo--d609a"};